import { render, staticRenderFns } from "./FormNoAplicados.vue?vue&type=template&id=35a068a3&"
import script from "./FormNoAplicados.vue?vue&type=script&lang=js&"
export * from "./FormNoAplicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports